/*
Copyright 2023, 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import { Trans } from "react-i18next";

import { ExternalLink } from "../button/Link";

export const AnalyticsNotice: FC = () => (
  <Trans i18nKey="analytics_notice">
    En cochant cette case, vous consentez à la collecte de données anonymes,
    qui seront utilisées pour améliorer Mimosa Call. Vous trouverez plus
    d&apos;informations sur les données collectées dans notre{" "}
    <ExternalLink href="https://portal.ztn0.net/privacy">
      Politique de vie privée
    </ExternalLink>{" "}
    et notre{" "}
    <ExternalLink href="https://portal.ztn0.net/privacy">
      Politique de cookies
    </ExternalLink>
    .
  </Trans>
);
